import React, { Component } from "react";
import ZPartner02Header from "./ZPartner01GrabHeader";
import ZPartner02Footer from "./ZPartner01GrabFooter";

export class ZPartner02Error extends Component {
    static displayName = ZPartner02Error.name;

    constructor(props) {
        super(props);
        this.state = {

        };
    }

    componentDidMount() {
        const links = [
            "https://fonts.googleapis.com/css?family=Lato:300&text=1234567890,.-",
            "/css/style.css",
            "/css/style-sr.css"
        ];

        links.forEach(href => {
            const link = document.createElement("link");
            link.rel = "stylesheet";
            link.href = href;
            document.head.appendChild(link);
        });
    }    
    
    render() {                   
        const query = new URLSearchParams(this.props.location.search);
        const errorCase = query.get("S");

        var errorMsg01 = "";
        var errorMsg02 = "";

        switch (errorCase)
        {
            case "alreadylink":
                errorMsg01 = "Your account [Lineman] has been linked.";
                errorMsg02 = "บัญชีสมาชิกของคุณได้ผูกกับบัญชีแล้ว";
                break;
            case "sralreadylink":
                errorMsg01 = "Your account [Starbucks] has been linked.";
                errorMsg02 = "บัญชีสมาชิกของคุณได้ผูกกับบัญชีแล้ว";
                break;
            case "api":
                errorMsg01 = "Your request could not be completed at this time. Please try again later";
                errorMsg02 = "ท่านทำรายการไม่สำเร็จกรุณาลองใหม่อีกครั้ง";
                break;
            case "newregisemaildup":
                errorMsg01 = "Email address is not available";
                errorMsg02 = "อีเมลนี้ลงทะเบียนแล้ว";
                break;
            case "newregislinkexpire":
                errorMsg01 = "Your email verification link has expired, please create a new account again.";
                errorMsg02 = "ลิงก์ของท่านหมดอายุแล้ว กรุณาลงทะเบียนสมาชิกใหม่อีกครั้ง";
                break;
            case "faildblink":
                errorMsg01 = "An error occurred while processing your request.";
                errorMsg02 = "[link]";
                break;
            case "failgrabnoti":
                errorMsg01 = "An error occurred while processing your request.";
                errorMsg02 = "[noti]";
                break;
            case "failcreatecrmprofile":
                errorMsg01 = "An error occurred while processing your request.";
                errorMsg02 = "[crm]";
                break;
            case "toomanyactivatevirtualcard":
                errorMsg01 = "An error occurred while processing your request.";
                errorMsg02 = "[card]";
                break;
            default:
                errorMsg01 = "An error occurred while processing your request.";
                errorMsg02 = "";
                break;
        }

        return (
            <>
                <ZPartner02Header />

                <main id="main">
                    <section className="top-sr-bg bg-gray1">
                        <div className="container">
                            <div className="row justify-content-between">
                                <div className="col col-md-6">
                                    <h1 className="text-headpage text-white mb-0 pt-3 pb-3 ">
                                        <span className="d-none">Starbucks® Rewards</span>
                                        <img src="media/rewards/starbucks-rewards-logo-2.png" alt="Starbucks® Rewards" className="img-fluid" style={{ maxWidth: '158px' }} />
                                    </h1>
                                </div>
                            </div>
                        </div>
                    </section>
                    <section className="section-sign-in overflow-hidden pb-5">
                        <div className="container p-1 p-md-0">                            
                            <div className="row justify-content-center px-1 px-md-5">
                                <div className="col-md-6 mb-3 pt-3">
                                    <div className="py-5 p-4 box-sign-in">
                                        <h2 className="req">
                                            {errorMsg01}
                                            <br />
                                            {errorMsg02}
                                        </h2>
                                    </div>
                                </div>
                            </div>
                        </div>                        
                    </section>
                </main>

                <ZPartner02Footer />
            </>            
        );
    }
}
